import { DeleteOrderToOrderGroupRequest } from '@/coreInfrastructureModule/axios/generated/orderGroupManage';

/**
 * 発注グループ解除のリクエストに変換する
 */
export class BulkDeleteOrderToOrderGroupAdapter {
  /**
   * 変換する
   * @param orderGroupId - 対象の発注グループID
   * @param orderIds - 対象の発注ID
   */
  public static adapt(orderGroupId: string, orderIds: string[]): DeleteOrderToOrderGroupRequest {
    const deleteOrderToOrderGroupRequest: DeleteOrderToOrderGroupRequest = {
      deleteOrderFromOrderGroupInfo: {
        orderGroupId,
        orderIds,
      },
    };
    return deleteOrderToOrderGroupRequest;
  }
}
